export default __webpack_public_path__ + "static/media/img1.80e8a827.svg";